import formatMoneyFromDollars from '@lib/money/formatMoneyFromDollars'

export const formatMoneyFromCents = (amountCents: number | string) => {
  if (typeof amountCents === 'string') {
    amountCents = parseFloat(amountCents)
  }
  if (isNaN(amountCents)) {
    return ''
  }

  const amountCentsDividedBy100 = amountCents / 100.0
  return formatMoneyFromDollars(amountCentsDividedBy100)
}
